import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import { type UpdateGroupRequest } from '../types'

const ZUpdateGroupApiResponse = z.object({
  asset_group_id: z.string(),
  group_name: z.string()
})

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZUpdateGroupApiResponse,
  error: z.boolean()
})

export type UpdateGroupApiResponse = z.infer<typeof ZUpdateGroupApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function updateGroup (
  groupId: string,
  updateGroupRequest: UpdateGroupRequest,
  onSuccess: (successResponse: UpdateGroupApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-service/api/v1/udp/groupManagement/assetGroup/${groupId}`

  interceptedAxios
    .put(url, updateGroupRequest)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        // istanbul ignore else
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
